import { Button, message } from "antd";
import { RezerwaContext } from "../../../context/rezerwaContext";
import { useContext, useEffect } from "react";
import axios from "../../../context/axiosConfig";
import { useAuth } from "../../../context/AuthContext";
import { useParams, useNavigate } from "react-router-dom"; // Dodano useNavigate
import isCan from "../../../components/isCan";
import { useState } from "react";

const SaveButton = () => {
	const { rezerwa, setrezerwa } = useContext(RezerwaContext);
	const { user, isAuthenticated } = useAuth();
	const { rezerwaid } = useParams();
	const navigate = useNavigate(); // Dodano useNavigate

	const hasInvalidBankAccount = (() => {
		const transfers =
			rezerwa?.rezerwa_data?.data?.rezerwa?.msr_transfers ?? [];
		const defaultTransferTypes =
			rezerwa?.rezerwa_data?.data?.default_values?.msr_transfers_types ??
			[];

		return (
			Array.isArray(transfers) &&
			transfers.some((transfer) => {
				const transferType = defaultTransferTypes.find(
					(type) =>
						type?.msr_transfers_types_id ===
						transfer?.msr_transfers_types_id
				);
				const isBankTransfer =
					transferType?.msr_transfers_types_bank_transfer === 1;
				if (!isBankTransfer) return false;

				const accountDigits = (
					transfer?.msr_transfers_account_number || ""
				).replace(/\s+/g, "");
				const accountOwner = (
					transfer?.msr_transfers_account_owner || ""
				).trim();
				return !/^\d{26}$/.test(accountDigits) || !accountOwner;
			})
		);
	})();

	const saveDataToDatabase = async () => {
		try {
			// Display a loading message
			const hide = message.loading("Zapisywanie danych...", 0);

			// Send data to the server
			const response = await axios.post("/rezerwa/update/data", {
				rezerwa: rezerwa?.rezerwa_data?.data?.rezerwa,
				rezerwaid: rezerwa?.msr_rezerwa_id,
				userid: user.user.mlg_users_id,
				changes: rezerwa.changes,
			});

			hide(); // Hide the loading message

			if (response.data.status) {
				message.success("Dane zapisane pomyślnie!");
				setrezerwa({ ...rezerwa, reload: !rezerwa.reload });
			} else {
				message.error(`Błąd zapisu: ${response.data.message}`);
			}
		} catch (error) {
			console.error("Error saving data:", error);
			message.error("Wystąpił błąd podczas zapisywania danych.");
		}
	};

	return (
		<Button
			disabled={!rezerwa?.changes?.length || hasInvalidBankAccount}
			onClick={saveDataToDatabase}
		>
			Zapisz
		</Button>
	);
};

export default SaveButton;
